/*  THIS IS A GENERATED FILE. Don't edit. Run yarn generate-icons from frontend folder. */
import { z } from 'zod'
import Add from './svg/add.svg'
import Arrowdown from './svg/arrow-down.svg'
import Arrowleft from './svg/arrow-left.svg'
import Arrowright from './svg/arrow-right.svg'
import Attachment from './svg/attachment.svg'
import Attempt from './svg/attempt.svg'
import Bankid from './svg/bank-id.svg'
import Bin from './svg/bin.svg'
import Book from './svg/book.svg'
import Calendar from './svg/calendar.svg'
import Checkmark from './svg/checkmark.svg'
import Chevrondown from './svg/chevron-down.svg'
import Chevronleft from './svg/chevron-left.svg'
import Chevronright from './svg/chevron-right.svg'
import Clock from './svg/clock.svg'
import Company from './svg/company.svg'
import Download from './svg/download.svg'
import Draghandle from './svg/drag-handle.svg'
import Duedate from './svg/due-date.svg'
import Exit from './svg/exit.svg'
import Feedback from './svg/feedback.svg'
import Files from './svg/files.svg'
import HideSource from './svg/hideSource.svg'
import House from './svg/house.svg'
import Info from './svg/info.svg'
import Lock from './svg/lock.svg'
import Logout from './svg/logout.svg'
import Multiplechat from './svg/multiple-chat.svg'
import Notesedit from './svg/notes-edit.svg'
import Programs from './svg/programs.svg'
import Publish from './svg/publish.svg'
import Question from './svg/question.svg'
import Quiz from './svg/quiz.svg'
import Read from './svg/read.svg'
import Remove from './svg/remove.svg'
import Retake from './svg/retake.svg'
import Ribbon from './svg/ribbon.svg'
import Rightarrow from './svg/right-arrow.svg'
import Search from './svg/search.svg'
import Settings from './svg/settings.svg'
import Statistics from './svg/statistics.svg'
import Synchronizearrow from './svg/synchronize-arrow.svg'
import Threearrows from './svg/three-arrows.svg'
import Timeclock from './svg/time-clock.svg'
import Unlock from './svg/unlock.svg'
import User from './svg/user.svg'
import Userscircle from './svg/users-circle.svg'
import Userstrio from './svg/users-trio.svg'
import Users from './svg/users.svg'
import Video from './svg/video.svg'
import Viewoff from './svg/view-off.svg'
import View from './svg/view.svg'
export const IconId = z.union([
  z.literal('add'),
  z.literal('arrow-down'),
  z.literal('arrow-left'),
  z.literal('arrow-right'),
  z.literal('attachment'),
  z.literal('attempt'),
  z.literal('bank-id'),
  z.literal('bin'),
  z.literal('book'),
  z.literal('calendar'),
  z.literal('checkmark'),
  z.literal('chevron-down'),
  z.literal('chevron-left'),
  z.literal('chevron-right'),
  z.literal('clock'),
  z.literal('company'),
  z.literal('download'),
  z.literal('drag-handle'),
  z.literal('due-date'),
  z.literal('exit'),
  z.literal('feedback'),
  z.literal('files'),
  z.literal('grid'),
  z.literal('hideSource'),
  z.literal('house'),
  z.literal('info'),
  z.literal('lock'),
  z.literal('logout'),
  z.literal('multiple-chat'),
  z.literal('notes-edit'),
  z.literal('programs'),
  z.literal('publish'),
  z.literal('question'),
  z.literal('quiz'),
  z.literal('read'),
  z.literal('remove'),
  z.literal('retake'),
  z.literal('ribbon'),
  z.literal('right-arrow'),
  z.literal('search'),
  z.literal('settings'),
  z.literal('statistics'),
  z.literal('synchronize-arrow'),
  z.literal('three-arrows'),
  z.literal('time-clock'),
  z.literal('unlock'),
  z.literal('user'),
  z.literal('users'),
  z.literal('users-circle'),
  z.literal('users-trio'),
  z.literal('video'),
  z.literal('view'),
  z.literal('view-off'),
])
export type IconId = z.infer<typeof IconId>
export const iconMap: Record<IconId, any> = {
  add:                 Add,
  'arrow-down':        Arrowdown,
  'arrow-left':        Arrowleft,
  'arrow-right':       Arrowright,
  attachment:          Attachment,
  attempt:             Attempt,
  'bank-id':           Bankid,
  bin:                 Bin,
  book:                Book,
  calendar:            Calendar,
  checkmark:           Checkmark,
  'chevron-down':      Chevrondown,
  'chevron-left':      Chevronleft,
  'chevron-right':     Chevronright,
  clock:               Clock,
  company:             Company,
  download:            Download,
  'drag-handle':       Draghandle,
  'due-date':          Duedate,
  exit:                Exit,
  feedback:            Feedback,
  files:               Files,
  grid:                Book,
  hideSource:          HideSource,
  house:               House,
  info:                Info,
  lock:                Lock,
  logout:              Logout,
  'multiple-chat':     Multiplechat,
  'notes-edit':        Notesedit,
  programs:            Programs,
  publish:             Publish,
  question:            Question,
  quiz:                Quiz,
  read:                Read,
  remove:              Remove,
  retake:              Retake,
  ribbon:              Ribbon,
  'right-arrow':       Rightarrow,
  search:              Search,
  settings:            Settings,
  statistics:          Statistics,
  'synchronize-arrow': Synchronizearrow,
  'three-arrows':      Threearrows,
  'time-clock':        Timeclock,
  unlock:              Unlock,
  user:                User,
  'users-circle':      Userscircle,
  'users-trio':        Userstrio,
  users:               Users,
  video:               Video,
  'view-off':          Viewoff,
  view:                View,
} as const
